import { z } from 'zod'

import { BadgeColorKeys } from '@/components/ui/badge'

export const CommunicationTypeEnum = z.enum(['Email', 'Notification', 'SMS'])

export type CommunicationType = z.infer<typeof CommunicationTypeEnum>

export const CommunicationStatusEnum = z.enum(['Completed', 'Scheduled', 'Ongoing', 'Processing'])

export type CommunicationStatus = z.infer<typeof CommunicationStatusEnum>

export const RecipientStatusEnum = z.enum(['sent', 'delivered', 'opened', 'clicked', 'replied'])

export type RecipientStatus = z.infer<typeof RecipientStatusEnum>

export const RECIPIENT_STATUS_COLOR_MAP: Record<RecipientStatus, BadgeColorKeys> = {
  [RecipientStatusEnum.enum.clicked]: 'green',
  [RecipientStatusEnum.enum.delivered]: 'blue',
  [RecipientStatusEnum.enum.opened]: 'orange',
  [RecipientStatusEnum.enum.replied]: 'green',
  [RecipientStatusEnum.enum.sent]: 'purple',
}

// TODO: Move it out of models
export const getRecipientStatusColor = (status: RecipientStatus): BadgeColorKeys =>
  RECIPIENT_STATUS_COLOR_MAP[status]

export interface MailingListItem {
  id: number
  value: string
}
